let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lAl0M")).then(() => parcelRequire('c6x12'));